export class DaxtraScoreAction {
  constructor(args) {
    this.PageStyle = args.PageStyle;
  }

  daxtraScore(score)
  {
    if (!isNaN(parseInt(score)))
    {
      return this.renderScoreBox(score)
    }
    else
      return this.renderScoreBox(0)
  }

  gradeScore(score){
    score = parseInt(score)
    switch (true) {
      case score >= 1 && score <= 20:
        return 1;
      case score >= 21 && score <= 40:
        return 2;
      case score >= 41 && score <= 60:
        return 3;
      case score >= 61 && score <= 80:
        return 4;
      case score >= 81 && score <= 100:
        return 5;
      default:
        return 0;
    }
  }

  loop(times, callback){
    for (let i = 0; i < times; i++) {
      callback(i);
    }
  }

  renderScoreBox = (score) => {
    const small_box = [];
    let convertedScore = this.gradeScore(score)
    let index = 0
    switch(convertedScore){
    case 1:
      this.loop(1, i => { small_box.push(this.smallBox('red')) });
      break;
    case 2:
      this.loop(2, i => { small_box.push(this.smallBox('yellow')) });
      break;
    case 3:
      this.loop(3, i => { small_box.push(this.smallBox('yellow')) });
      break;
    case 4:
      this.loop(4, i => { small_box.push(this.smallBox('green')) });
      break;
    case 5:
      this.loop(5, i => { small_box.push(this.smallBox('green')) });
      break;
    }
    index = convertedScore
    for(let i = index; i < 5; i++){
      small_box.push(this.smallBox('grey'));
    }
    return small_box;
  }

  renderSkillScore = (job_application_skills) => {
    const layout = [];
    if(job_application_skills.matching_skills){
      for (const [key, value] of Object.entries(job_application_skills.matching_skills)) {
        layout.push(this.smallSkill(key, value));
      }
    }

    if(job_application_skills.not_matching_skills){
        for (const [key, value] of Object.entries(job_application_skills.not_matching_skills)) {
        layout.push(this.smallSkill(key, 0));
      }
    }

    return layout;
  }

  smallBox(color){
    return <div className={`${this.PageStyle.SmallBox} ${color}-box-bg`}></div>
  }

  smallSkill(key, value){
    return <div className={`${this.PageStyle.ScoreBox__SkillDetail}`}>
      <span className ={`${this.PageStyle.ScoreBox__Skills_Name}`}>{key.replace(/_/g, " ")}</span>
      <span className={`${this.PageStyle.ScoreBox__Skills_Score}`}>{this.renderScoreBox(value)}</span>
    </div>
  }
}